import React, { useState, useEffect } from 'react'
import { Alert, Button, Spin } from 'antd'
import { ReloadOutlined, ExclamationCircleOutlined } from '@ant-design/icons'

const BackendStatus = ({ onBackendAvailable }) => {
  const [isChecking, setIsChecking] = useState(false)
  const [lastCheck, setLastCheck] = useState(null)

  const checkBackendStatus = async () => {
    setIsChecking(true)
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:3001/api'}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })

      if (response.ok) {
        onBackendAvailable?.()
        return true
      }
      return false
    } catch (error) {
      console.error('Backend check failed:', error)
      return false
    } finally {
      setIsChecking(false)
      setLastCheck(new Date())
    }
  }

  const handleRetry = () => {
    checkBackendStatus()
  }

  const handleReload = () => {
    window.location.reload()
  }

  useEffect(() => {
    // Check immediately on mount
    checkBackendStatus()

    // Set up periodic checks every 10 seconds
    const interval = setInterval(checkBackendStatus, 10000)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md w-full">
        <Alert
          message="Backend Indisponível"
          description={
            <div className="space-y-4">
              <p>
                O servidor backend não está disponível. Verifique se o servidor está rodando e tente novamente.
              </p>
              {lastCheck && (
                <p className="text-sm text-gray-500">
                  Última verificação: {lastCheck.toLocaleTimeString()}
                </p>
              )}
              <div className="flex space-x-2">
                <Button
                  type="primary"
                  icon={isChecking ? <Spin size="small" /> : <ReloadOutlined />}
                  onClick={handleRetry}
                  loading={isChecking}
                >
                  {isChecking ? 'Verificando...' : 'Tentar Novamente'}
                </Button>
                <Button
                  icon={<ReloadOutlined />}
                  onClick={handleReload}
                >
                  Recarregar Página
                </Button>
              </div>
            </div>
          }
          type="error"
          icon={<ExclamationCircleOutlined />}
          showIcon
        />
      </div>
    </div>
  )
}

export default BackendStatus